import React, { useState, useEffect } from "react";

const BreakingTicker = () => {
    const [breakingNews, setBreakingNews] = useState([]);
    const [loading, setLoading] = useState(true);

    // Fallback news if API fails
    const fallbackNews = [
        "Kohla News: Your trusted source for breaking news from Okara, Punjab",
        "Stay updated with latest news from Pakistan and around the world",
        "Follow Kohla News for accurate and timely news coverage",
        "Breaking: Major political developments in Punjab",
        "Weather alert: Rain expected in multiple cities",
        "Subscribe to Kohla News for daily updates",
    ];

    // Fetch breaking news from RSS feeds
    const fetchBreakingNews = async () => {
        try {
            const sources = [
                "https://api.rss2json.com/v1/api.json?rss_url=https://www.thenews.com.pk/rss/1/1",
                "https://api.rss2json.com/v1/api.json?rss_url=https://jang.com.pk/rss/1/1",
                "https://api.rss2json.com/v1/api.json?rss_url=https://www.express.pk/feed/",
            ];

            let allHeadlines = [];

            for (const source of sources) {
                try {
                    const response = await fetch(source);
                    if (response.ok) {
                        const data = await response.json();
                        if (data.status === "ok" && data.items) {
                            const headlines = data.items
                                .slice(0, 5)
                                .map((item) => {
                                    let title = item.title || "";
                                    title = title.replace(/&quot;/g, '"');
                                    title = title.replace(/&amp;/g, '&');
                                    title = title.replace(/&lt;/g, '<');
                                    title = title.replace(/&gt;/g, '>');
                                    title = title.replace(/&#39;/g, "'");
                                    return `🔴 ${title}`;
                                })
                                .filter((title) => title.length > 10);
                            
                            allHeadlines = [...allHeadlines, ...headlines];
                        }
                    }
                } catch (err) {
                    console.log("Source failed, trying next...");
                }
            }

            if (allHeadlines.length > 0) {
                const uniqueHeadlines = [...new Set(allHeadlines)].slice(0, 15);
                setBreakingNews(uniqueHeadlines);
                setLoading(false);
            } else {
                setBreakingNews(fallbackNews);
                setLoading(false);
            }
        } catch (error) {
            console.error("Error fetching breaking news:", error);
            setBreakingNews(fallbackNews);
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchBreakingNews();
        const refreshInterval = setInterval(fetchBreakingNews, 60000);
        return () => clearInterval(refreshInterval);
    }, []);

    if (loading) {
        return (
            <div className="bg-red-600 py-2 overflow-hidden">
                <div className="container mx-auto px-4">
                    <div className="flex items-center">
                        <span className="bg-white text-red-600 font-bold px-3 py-1 rounded mr-4 text-sm whitespace-nowrap">
                            🔴 BREAKING
                        </span>
                        <div className="text-white font-medium">Loading latest news...</div>
                    </div>
                </div>
            </div>
        );
    }

    if (breakingNews.length === 0) {
        return (
            <div className="bg-red-600 py-2 overflow-hidden">
                <div className="container mx-auto px-4">
                    <div className="flex items-center">
                        <span className="bg-white text-red-600 font-bold px-3 py-1 rounded mr-4 text-sm whitespace-nowrap">
                            🔴 BREAKING
                        </span>
                        <div className="text-white font-medium">Welcome to Kohla News</div>
                    </div>
                </div>
            </div>
        );
    }

    // Double the news for seamless loop
    const tickerNews = [...breakingNews, ...breakingNews];

    return (
        <div className="bg-red-600 py-2 overflow-hidden">
            <div className="container mx-auto px-4">
                <div className="flex items-center">
                    <span className="bg-white text-red-600 font-bold px-3 py-1 rounded mr-4 text-sm whitespace-nowrap flex-shrink-0">
                        🔴 BREAKING
                    </span>
                    
                    <div className="overflow-hidden flex-1">
                        <div className="animate-marquee whitespace-nowrap">
                            {tickerNews.map((news, index) => (
                                <span key={index} className="text-white font-medium mx-8">
                                    {news}
                                </span>
                            ))}
                        </div>
                    </div>

                    <span className="ml-4 flex items-center gap-1 text-white text-xs whitespace-nowrap flex-shrink-0">
                        <span className="w-2 h-2 bg-white rounded-full animate-pulse"></span>
                        LIVE
                    </span>
                </div>
            </div>

            <style jsx>{`
                @keyframes marquee {
                    0% { transform: translateX(0); }
                    100% { transform: translateX(-50%); }
                }
                .animate-marquee {
                    animation: marquee 60s linear infinite;
                    display: inline-flex;
                }
                @keyframes pulse {
                    0%, 100% { opacity: 1; }
                    50% { opacity: 0.3; }
                }
                .animate-pulse {
                    animation: pulse 1.5s ease-in-out infinite;
                }
            `}</style>
        </div>
    );
};

export default BreakingTicker;